import axios from "axios";

const axiosInstance = axios.create({
	baseURL: process.env.INYARWANDA_STORAGE_API,
	headers: {
		Accepted: "appication/json",
		"Content-Type": "application/json",
		apiKey: process.env.STORAGE_API_KEY,
	},
});

axiosInstance.interceptors.request.use(
	(config) => {
		const currentUser = JSON.parse(localStorage.getItem("au"));
		const token = currentUser?.atkn;
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => Promise.reject(error)
);

export default axiosInstance;
